import { forwardRef } from "react";
import { InputAdornment, TextFieldProps } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import {
  CustomTextAreaField,
  SingleLineTextField,
} from "./customTextFieldStyles";

export type CustomTextFieldProps = TextFieldProps & {
  showSearchIconStart?: boolean;
};

const CustomTextField = forwardRef<HTMLDivElement, CustomTextFieldProps>(
  ({ showSearchIconStart = false, InputProps, ...props }, ref) => {
    const startAdornment =
      showSearchIconStart && !InputProps?.startAdornment ? (
        <InputAdornment position="start" sx={{ mr: 0, ml: -0.5 }}>
          <SearchIcon sx={{ color: "#989898", fontSize: 20 }} />
        </InputAdornment>
      ) : (
        InputProps?.startAdornment
      );

    return (
      <SingleLineTextField
        {...props}
        ref={ref}
        InputProps={{
          ...InputProps,
          startAdornment,
        }}
      />
    );
  },
);

CustomTextField.displayName = "CustomTextField";

export default CustomTextField;
export { CustomTextAreaField };
